export default "__VITE_ASSET__ca267596__"